module.exports = __webpack_public_path__ + "assets/img/step_key.a518a870.png";